import { render, staticRenderFns } from "./language-selection.vue?vue&type=template&id=627ea928&scoped=true"
import script from "./language-selection.vue?vue&type=script&lang=ts"
export * from "./language-selection.vue?vue&type=script&lang=ts"
import style0 from "./language-selection.vue?vue&type=style&index=0&id=627ea928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627ea928",
  null
  
)

export default component.exports